import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VatCalculationService {
  /**
   * Oblicza wartość brutto na podstawie netto i stawki VAT.
   * @param netAmount Kwota netto
   * @param vatRate Stawka VAT (np. 23 dla 23%)
   * @returns Kwota brutto
   */
  calculateGross(netAmount: number, vatRate: number): number {
    if (!this.isValidAmount(netAmount) || !this.isValidRate(vatRate)) return 0;
    return this.roundToTwo(netAmount * (1 + vatRate / 100));
  }

  /**
   * Oblicza wartość netto na podstawie brutto i stawki VAT.
   * @param grossAmount Kwota brutto
   * @param vatRate Stawka VAT (np. 23 dla 23%)
   * @returns Kwota netto
   */
  calculateNet(grossAmount: number, vatRate: number): number {
    if (!this.isValidAmount(grossAmount) || !this.isValidRate(vatRate)) return 0;
    return this.roundToTwo(grossAmount / (1 + vatRate / 100));
  }

  /**
   * Oblicza wartość VAT na podstawie kwoty netto i stawki VAT.
   * @param netAmount Kwota netto
   * @param vatRate Stawka VAT (np. 23)
   * @returns Kwota VAT
   */
  calculateVatValue(netAmount: number, vatRate: number): number {
    if (!this.isValidAmount(netAmount) || !this.isValidRate(vatRate)) return 0;
    return this.roundToTwo(netAmount * vatRate / 100);
  }

  /**
   * Oblicza wartość VAT na podstawie kwoty brutto i stawki VAT.
   * @param grossAmount Kwota brutto
   * @param vatRate Stawka VAT
   * @returns Kwota VAT
   */
  calculateVatFromGross(grossAmount: number, vatRate: number): number {
    if (!this.isValidAmount(grossAmount) || !this.isValidRate(vatRate)) return 0;
    const net = this.calculateNet(grossAmount, vatRate);
    return this.roundToTwo(grossAmount - net);
  }

  round(value: number): number {
    return this.roundToTwo(value);
  }

  private isValidAmount(value: any): value is number {
    return typeof value === 'number' && !isNaN(value);
  }

  private isValidRate(rate: any): rate is number {
    return typeof rate === 'number' && rate >= 0;
  }

  private roundToTwo(value: number): number {
    return Math.round(value * 100) / 100;
  }
}
